<template>
  <div>
    <div class="ContainerSearchInput">
      <div class="textRegister">
        <span>
          <b-icon-person-lines-fill></b-icon-person-lines-fill>Responsáveis
          Registrados - 12</span
        >
      </div>
      <div class="searchInput" style="height: 100%; align-items: flex-end">
        <b-form-select
          v-if="showFilterTypes"
          id="filterType"
          class="searchFilterTypes"
          size="sm"
          value-field="value"
          text-field="text"
          v-model="filterType"
          :options="filterTypes"
        ></b-form-select>

        <b-form-select
          class="searchFilter"
          :style="
            showFilterTypes && `border-left: none; border-radius: 0 0 0 0`
          "
          size="sm"
          value-field="value"
          text-field="text"
          v-model="type"
          :options="filterCombobox"
          @change="handleShowFilterTypes"
        ></b-form-select>

        <b-input
          class="inputSearch"
          size="sm"
          placeholder="Pesquisar"
          v-model="textPesquisa"
          @keyup.enter="read"
        ></b-input>

        <b-button size="sm" @click="read" class="searchBtn">
          <b-icon-search></b-icon-search>
        </b-button>
        <div class="searchInput" style="justify-content: flex-end">
          <button class="searchAll" @click="read">ver tudo</button>
        </div>
      </div>
    </div>
    <div
      class="ContentTable"
      v-if="this.dataLength > 0"
      style="color: #3a4750; width: 100%"
    >
      <div
        v-for="responsible in listResponsibles"
        :key="responsible.id"
        class="rowResp"
        @click="findById(responsible.id)"
        style="border-left: solid 10px #f2a83e"
      >
        <div class="celTable" style="width: 20%">
          <span class="textEllipsis">
            <strong>Nome: </strong>
            <strong
              style="
                color: #3e66ae;
                font-weight: bold;
                text-transform: uppercase;
                padding-left: 3px;
              "
              >{{ responsible.nome }}</strong
            >
          </span>
          <span class="textEllipsis">
            <strong>CPF: </strong>
            {{ responsible.cpf || "000.000.00-00" }}</span
          >
        </div>
        <div class="celTable" style="width: 15%">
          <span class="textEllipsis">
            <strong>Conselho: </strong>
            {{ responsible.conselho || "Sem Informações" }}</span
          >
          <span class="textEllipsis">
            <strong>Nº Registro: </strong>
            {{ responsible.creatCfta ? responsible.creatCfta : "--" }}</span
          >
        </div>
        <div class="celTable" style="width: 15%">
          <span class="textEllipsis"
            ><strong>Telefone: </strong
            >{{ responsible.telefone || "(00) 0000-0000" }}</span
          >
          <span class="textEllipsis">
            <strong>Whatsapp: </strong>
            {{ responsible.celular || "(00) 0000-0000" }}
          </span>
        </div>
        <div class="celTable" style="width: 30%">
          <span class="textEllipsis"
            ><strong>Endereço: </strong
            >{{ responsible.endereco || "Sem Informações" }} -
            {{ responsible.bairro }} , {{ responsible.numero || "S/N" }}</span
          >
          <span class="textEllipsis"
            ><strong>Cidade: </strong
            >{{ responsible.cidade || "Sem Informações" }} -
            {{ responsible.uf }}</span
          >
        </div>
        <div class="celTable" style="width: 15%">
          <span><strong>Status: </strong>{{ responsible.status }}</span>
        </div>
        <div class="celTableActions">
          <span class="celInfos" @click.stop="handleOpenModal(responsible.id)"
            ><b-icon-trash-fill scale="1.5"
          /></span>
        </div>
      </div>
    </div>
    <div v-else class="defaultSearch">
      <span>Não há dados para exibir ...</span>
    </div>
    <div v-if="spinGeneral" class="loadingLazy">
      <div class="loader"></div>
    </div>
    <!-- <div class="setBtn">
      <button @click="previousPage" :disabled="page === 1" class="itemBtn">
        <b-icon-chevron-left></b-icon-chevron-left>
      </button>
      <button class="centerItemBtn">{{ page }}</button>
      <button @click="nextPage" :disabled="this.dataLength < 9" class="itemBtn">
        <b-icon-chevron-right></b-icon-chevron-right>
      </button>
    </div> -->

    <ModalConfirm
      modalName="modal-confirm-delete-responsible"
      title="Remover Responsável"
      subtitle="Esta ação não pode ser desfeita. Deseja continuar ?"
      :rightButtonClick="destroy"
      @modalClosed="selectedResponsibleId = null"
    />
  </div>
</template>

<script>
import moment from "moment";
import toastAlertErros from "../../utils/toastAlertErros";
import { mapMutations, mapState } from "vuex";
import ServiceResponsible from "../../services/serviceResponsible";
import ModalConfirm from "../Modals/ModalConfirm.vue";

export default {
  components: {
    ModalConfirm,
  },
  data() {
    return {
      listResponsibles: [],
      tabIndex: 0,
      textPesquisa: "",
      type: "",
      startDate: "",
      endDate: "",
      dataLength: 0,
      page: 1,
      spinGeneral: false,
      filterCombobox: [
        { value: "nomeFuncionario", text: "Nome" },
        { value: "cpf", text: "CPF" },
        { value: "funcao", text: "Função" },
        { value: "celular", text: "Contato" },
        { value: "status", text: "Status" },
        { value: "", text: "Todos" },
      ],
      filterTypes: [
        { value: "includes", text: "Contém" },
        { value: "start", text: "Inicia por" },
      ],
      filterType: "includes",
      showFilterTypes: false,
      selectedResponsibleId: null,
    };
  },
  methods: {
    ...mapMutations(["SET_DATA_SEARCH_FROM_RESPONSIBLE"]),
    async read() {
      try {
        this.spinGeneral = true;
        const result = await ServiceResponsible.findAll();

        this.dataLength = result.length;
        this.listResponsibles = result;
      } catch (error) {
        return this.$toast.open({
          message: "Não foi possível listar os funcionarios",
          type: "warning",
        });
      } finally {
        this.spinGeneral = false;
      }
      if (this.dataLength < 9) {
        this.clearSearch();
      }
    },

    clearSearch() {
      this.textPesquisa = "";
      this.type = "";
    },

    async destroy() {
      try {
        await ServiceResponsible.delete(this.selectedResponsibleId);

        await this.read();

        return this.$toast.open({
          message: "Responsável deletado!",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else toastAlertErros.validateMessage(error, this.$toast);
      }
    },

    async findById(id) {
      try {
        const responsible = await ServiceResponsible.findById(id);

        this.openModalToReceive(responsible);
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else
          this.$toast.open({
            message: "Ocorreu um erro ao ler informações",
            type: "info",
          });
      }
    },

    openModalToReceive(responsible) {
      this.SET_DATA_SEARCH_FROM_RESPONSIBLE(responsible);
      this.$emit("clickEditResponsible");
    },

    nextPage() {
      this.read((this.page += 1));
    },

    previousPage() {
      if (this.page === 1) {
        return;
      } else {
        this.read((this.page -= 1));
      }
    },

    handleShowFilterTypes() {
      const types = ["nomeFuncionario", "cpf", "funcao", "celular", "status"];

      if (types.includes(this.type)) {
        this.showFilterTypes = true;
        return;
      }

      this.showFilterTypes = false;
    },

    handleOpenModal(responsibleId) {
      this.selectedResponsibleId = responsibleId;
      this.$bvModal.show("modal-confirm-delete-responsible");
    },
  },
  created() {
    this.read(1);
  },
  computed: {
    ...mapState({
      dataPermissions: (state) => state.dataPermissions,
      isSearchRegisters: (state) => state.isSearchRegisters,
    }),
    lerEmployee() {
      return this.dataPermissions?.cadastros?.novoCliente?.ler ?? true;
    },
  },
  watch: {
    isSearchRegisters() {
      this.read();
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>

<style scoped>
.ContentTable {
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 10px;
  gap: 5px;
  width: 100%;
  min-height: 50vh;
  max-width: 100%;
}

.rowResp {
  display: flex;
  align-items: center;
  background: #f8f8f8;
  border: 1px solid rgb(226, 226, 226);
  border-radius: 4px;
  text-align: center;
  height: 65px;
  gap: 20px;
  padding: 2px 20px;
  cursor: context-menu;
  font-size: 12px;
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.207);
}

.rowResp:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}

.celTable {
  display: flex;
  flex-direction: column;
  text-align: start;
}

.celTableActions {
  display: flex;
  gap: 10px;
  height: 50px;
  text-align: center;
  justify-content: flex-end;
  align-items: center;
}

.celInfos {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(131 130 130);
  border-radius: 5px;
  height: 25px;
  width: 25px;
  font-size: 10px !important;
  font-weight: 100 !important;
  padding: 5px 10px;
  color: whitesmoke;
}

.situationBall {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  border: 1px solid rgb(31, 30, 30);
}

.notResult {
  max-height: 50px;
  border-radius: 50%;
  max-width: 50px;
}

tr:nth-child(even) {
  background: #f2f3f3;
}

th {
  font-weight: 500;
  font-size: 12px;
}

td {
  text-transform: capitalize;
}

.btnActions {
  height: 25px;
  display: flex;
  justify-content: center;
}

.dropdown-menu {
  font-size: 12px;
  min-width: 5rem !important;
  width: 5rem !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  color: red;
  background: red;
  text-align: center;
  list-style: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
}

.searchFilter {
  width: 150px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
}

.searchFilter:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.searchFilterTypes {
  width: 150px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
}

.searchFilterTypes:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.custom-select {
  left: 4px;
  position: relative;
  border-right: none;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid rgb(195, 193, 193);
  -moz-appearance: none;
  appearance: none;
}

.ContainerSearchInput {
  display: flex;
  align-items: center;
  height: 37px;
  width: 100%;
  justify-content: space-between;
  padding: 0 20px;
}

.textRegister span {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.searchInput {
  width: 50%;
  display: flex;
}

.searchAll {
  justify-content: center;
  color: #3a4750;
  font-size: 13px;
  padding: 5px 20px;
  font-weight: bold;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAll:hover {
  background: rgb(205, 205, 205);
}

.form-control-sm {
  padding: 0.25rem 1.5rem;
  height: 30px;
}

.textEllipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

input {
  border: 1px solid rgb(195, 193, 193);
  border-radius: 5px;
  height: 30px;
}

.searchBtn {
  right: 10px;
  height: 30px;
  position: relative;
  background: whitesmoke;
  color: black;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  border-color: #c3c1c1;
}

input:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

button:focus {
  box-shadow: none;
}

.pagMonth {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.defaultSearch {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 40vh;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
}

.defaultSearch span {
  font-size: 1rem;
  font-weight: bold;
  color: gray;
}

.loadingLazy {
  position: absolute;
  bottom: 20px;
  height: 50vh;
  width: calc(100% - 100px);
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(140, 140, 140);
}

.loader {
  animation: rotate 1s infinite;
  height: 50px;
  width: 50px;
  opacity: 0.5;
}

.loader:before,
.loader:after {
  border-radius: 50%;
  content: "";
  display: block;
  height: 20px;
  width: 20px;
}

.loader:before {
  animation: ball1 1s infinite;
  background-color: #403b74;
  box-shadow: 30px 0 0 #f2a83e;
  margin-bottom: 10px;
}

.loader:after {
  animation: ball2 1s infinite;
  background-color: #0051a9;
  box-shadow: 30px 0 0 #48b865;
}

@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg) scale(0.8);
    -moz-transform: rotate(0deg) scale(0.8);
  }

  50% {
    -webkit-transform: rotate(360deg) scale(1.2);
    -moz-transform: rotate(360deg) scale(1.2);
  }

  100% {
    -webkit-transform: rotate(720deg) scale(0.8);
    -moz-transform: rotate(720deg) scale(0.8);
  }
}

@keyframes ball1 {
  0% {
    box-shadow: 30px 0 0 #f2a83e;
  }

  50% {
    box-shadow: 0 0 0 #f2a83e;
    margin-bottom: 0;
    -webkit-transform: translate(15px, 15px);
    -moz-transform: translate(15px, 15px);
  }

  100% {
    box-shadow: 30px 0 0 #f2a83e;
    margin-bottom: 10px;
  }
}

@keyframes ball2 {
  0% {
    box-shadow: 30px 0 0 #48b865;
  }

  50% {
    box-shadow: 0 0 0 #48b865;
    margin-top: -20px;
    -webkit-transform: translate(15px, 15px);
    -moz-transform: translate(15px, 15px);
  }

  100% {
    box-shadow: 30px 0 0 #48b865;
    margin-top: 0;
  }
}

.setBtn {
  display: flex;
  flex-direction: row;
  margin: 0 1rem 1rem 0;
  gap: 10px;
  bottom: 0;
  right: 0;
  position: relative;
  justify-content: flex-end;
}

.itemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #3a4750;
}

.itemBtn:hover {
  background: #3a4750;
  color: whitesmoke;
}

.itemBtn:disabled {
  opacity: 0;
}

.centerItemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #1b3159;
  cursor: auto;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .ContainerSearchInput {
    padding: 3px;
  }
  .textRegister {
    font-size: 12px;
  }
  .searchInput {
    width: 60%;
  }
  .searchFilter {
    height: 25px;
    font-size: 11px;
  }
  .form-control-sm {
    padding: 0.25rem 1.2rem;
    height: 25px;
    font-size: 12px;
  }
  .searchBtn {
    right: 10px;
    height: 25px;
    display: flex;
    align-items: center;
  }
  .searchAll {
    font-size: 11px;
    padding: 2px 10px;
  }
  .ContentTable {
    height: 50vh;
    max-height: 50vh;
    padding: 5px;
  }
  .headTable {
    height: 25px;
  }
  .trTable {
    height: 25px;
    font-size: 11px;
  }
  .setBtn {
    margin: 0 1rem 10px 0;
  }

  .itemBtn {
    width: 18px;
    height: 18px;
  }

  .centerItemBtn {
    width: 18px;
    height: 18px;
  }
}

@media screen and (max-width: 700px) {
  .ContainerSearchInput {
    display: flex;
    align-items: center;
    height: 70px;
    gap: 5px;
    width: 100%;
    justify-content: center;
    padding: 0;
    flex-direction: column;
  }

  .searchInput {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 3px 0 0;
  }

  .ContentTable {
    padding: 5px;
  }

  .searchInputAll {
    width: 150px !important;
  }

  .rowResp {
    gap: 5px;
    padding: 2px 5px;
    font-size: 10px;
    border-left: 5px solid rgb(64, 59, 116) !important;
  }

  .ContentTable {
    display: flex;
    flex-direction: column;
    overflow: auto;
    flex-wrap: wrap;
  }
  .celTableInfos {
    display: none;
  }

  .celTable {
    width: 33% !important;
  }

  .ContentTable {
    padding: 5px;
    overflow: auto;
    gap: 2px;
  }

  .notResult {
    display: none;
  }

  .trTable {
    font-size: 9px;
  }

  .whatsapp {
    display: none;
  }

  .searchAll {
    font-size: 10px;
    padding: 5px 10px;
  }

  .form-control-sm {
    padding: 0.25rem 0.5rem !important;
    font-size: 10px;
  }

  .searchFilter {
    width: 100px;
    font-size: 10px;
  }
}
</style>